<template>
  <!-- Muelle de compositores flotantes: el más nuevo a la derecha. Los que
       viven en el panel de lectura se teletransportan allí sin desmontarse. -->
  <div
    class="fixed bottom-0 z-50 flex flex-row-reverse items-end pointer-events-none"
    :class="isNarrow ? 'right-2 gap-2' : 'right-4 gap-3'"
  >
    <Teleport
      v-for="s in uiStore.composerSessions"
      :key="s.id"
      :to="uiStore.inlineComposerTarget || 'body'"
      :disabled="!(s.host === 'inline' && uiStore.inlineComposerTarget)"
    >
      <EmailComposer
        v-show="!(isNarrow && anyFloatingOpen && s.host === 'floating' && s.window === 'minimized')"
        :session-id="s.id"
        :inline="s.host === 'inline' && !!uiStore.inlineComposerTarget"
        :window-state="s.window"
        :narrow="isNarrow"
        :mode="s.mode"
        :email-id="s.emailId || undefined"
        :draft="s.draft"
        :initial-template="s.initialTemplate"
        :open-templates-on-mount="s.openTemplatesOnMount"
        :template-context="s.templateContext || undefined"
        :attachment-source="s.attachmentSource || undefined"
        :initial-subject="s.initialSubject || undefined"
        :context-module="s.contextModule || undefined"
        :context-entity-id="s.contextEntityId || undefined"
        :context-entity-id-number="s.contextEntityIdNumber || undefined"
        :initial-to="s.initialTo || undefined"
        :initial-cc="s.initialCc || undefined"
        :initial-body-html="s.initialBodyHtml || undefined"
        :in-reply-to="s.threadHeaders?.inReplyTo"
        :references="s.threadHeaders?.references"
      />
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useMediaQuery } from '@vueuse/core';
import { useUiStore } from '@/stores';
import EmailComposer from './EmailComposer.vue';

const uiStore = useUiStore();

const isNarrow = useMediaQuery('(max-width: 1023px)');

const anyFloatingOpen = computed(() =>
  uiStore.composerSessions.some(s => s.host === 'floating' && s.window !== 'minimized')
);
</script>
